import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-reset-dialog',
    templateUrl: './reset-dialog.component.html',
    styleUrls: ['./reset-dialog.component.scss'],
    standalone: false
})
export class ResetDialogComponent {

  constructor(public dialogRef: MatDialogRef<ResetDialogComponent>) { }

  confirmReset(): void {
    this.dialogRef.close(true);
  }
}
